import * as React from 'react';
import {connect} from 'react-redux';
import {BasePage} from '../reusableComponents/BasePage';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {Form} from '../reusableComponents/FormComponents/Form';
import './profile.scss';
import {isFormEmpty} from '../../utils/generalUtils';
import {updateUserPassword} from '../../services/userService';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {showAlert} from '../../actions/miscellaneousActions';

export interface IUpdatePasswordProps {
    Email: string;
    history: IHistory;
}

export class UpdatePasswordImpl extends React.PureComponent<IUpdatePasswordProps, {}> {
    constructor(props: IUpdatePasswordProps) {
        super(props);
    }

    public handleSubmit = async (value) => {
        if (isFormEmpty(value)) {
            return;
        }
        if (value.newPassword.length < 8) {
            showAlert({
                    title: 'Oops..!!',
                    text: 'Password should have minimum 8 characters.',
                    type: 'error',
                    closeOnConfirm: true
                },
                'submission');
            return;
        }

        if (value.newPassword !== value.confirmPassword) {
            showAlert({
                    title: 'Oops..!!',
                    text: 'New password and Confirm password must be same.',
                    type: 'error',
                    closeOnConfirm: true
                },
                'submission');
            return;
        }
        await updateUserPassword(value.oldPassword, value.newPassword, value.confirmPassword, this.props.Email, this.props.history);
    }

    public render() {
        return <BasePage baseClassName="update-password" icon="key" title="Update Password">
            <Form model="forms.updatePasswordForm" onSubmit={this.handleSubmit}>
                <InputField
                    id="oldPassword"
                    key={1}
                    hintText=""
                    label="Old Password:"
                    type="password"
                    required
                    model=".oldPassword"
                />
                <InputField
                    key={2}
                    id="password"
                    hintText=""
                    label="New Password:"
                    type="password"
                    required
                    model=".newPassword"
                />
                <InputField
                    key={3}
                    id="confimPassword"
                    hintText=""
                    label="Confirm Password:"
                    type="password"
                    required
                    model=".confirmPassword"
                />
                <FormFooter
                    submitLabel="Update"
                />
            </Form>
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    return {
        Email: ownProps.match.params.email
    };
}

export const UpdatePassword =
    withRouter(connect<{}, {}, IUpdatePasswordProps>(mapStateToProps)(UpdatePasswordImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Profile/UpdatePassword.tsx